export const applicationIdValidatorMessage = () => 'Please enter a valid Application ID.';
